import { database, fieldValue } from './firebase';

const collectionName = 'subscribers';
export const subscribeEmail = async (
  email: string
): Promise<string | undefined> => {
  try {
    const snapshotEmail = await database
      .collection(collectionName)
      .where('email', '==', email)
      .get();
    const emailExist = !snapshotEmail.empty;
    if (emailExist) {
      return 'อีเมลนี้ได้ทำการลงทะเบียนไปแล้ว';
    } else {
      await database
        .collection(collectionName)
        .doc()
        .set({ email, createdAt: fieldValue.serverTimestamp() });
      return undefined;
    }
  } catch (error) {
    return error;
  }
};
